const normalizeOptionId = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  return String(value);
};

export const mapSettlementPaymentTypeOptions = (options = []) =>
  options.map((option) => ({
    id: normalizeOptionId(option.key ?? option.value),
    label: option.label,
  }));

export const buildSettlementPaymentTypeDisplayMap = (options = []) =>
  options.reduce((acc, option) => {
    acc[option.id] = option.label;
    return acc;
  }, {});
